<div class="subheader">
  <svg-icon style="height: 20px" [svgStyle]="{'width.px': 20, 'height.px': 20}" src="/assets/icons/thumb_2.svg"></svg-icon>
  <div class="text light">
    {{hostel?.propertyRecommendationCount ?? 0}}&nbsp;recommendations
  </div>
</div>

<div class="avatars">
  <div *ngFor="let r of top4Recommendations" class="avatar">
    <ng-container *ngIf="r.backpacker?.profilePicture">
      <img ngOptimizedImage [ngSrc]="r.backpacker?.profilePicture" [fill]="true" alt="">
    </ng-container>
    <ng-container *ngIf="!r.backpacker?.profilePicture">
      <img ngOptimizedImage ngSrc="https://storage.googleapis.com/hostel-hop-public-storage/images/empty_profile.png" [fill]="true" alt="">
    </ng-container>
  </div>
  <span>{{label}}</span>
</div>
<div class="button-wrapper" *ngIf="(hostel?.recommendationsFromBackpackers?.length ?? 0) > 4">
  <button class="btn btn-theme btn-large" [disabled]="!hostel?.recommendationsFromBackpackers?.length">
    <span>View all&nbsp;{{hostel?.recommendationsFromBackpackers?.length}}&nbsp;Recommendations</span>
  </button>
</div>
